module.exports = __webpack_public_path__ + "img/ics_o_shipping_service_active.8ad16763.svg";